import {defineStore} from "pinia";
import {send} from "@/composables/apiClient";

// Caches the consumer asset-type catalog (GET /asset-types?consumer=1) so the
// persona icon/color/labels are table-driven: a new type added on the backend
// shows up with no app change. Resolved by asset_type_id (or slug).
export const useAssetTypeStore = defineStore("assetTypeStore", {
    state: () => ({
        consumer: [],
        loaded: false,
        loading: false,
    }),

    getters: {
        byAssetTypeId: (state) => (id) => {
            if (id === null || id === undefined) return null;
            const n = Number(id);
            return state.consumer.find((c) => Number(c.id) === n) ?? null;
        },
        bySlug: (state) => (slug) => state.consumer.find((c) => c.slug === slug) ?? null,
    },

    actions: {
        async fetchConsumer(force = false) {
            if (this.loading || (this.loaded && !force)) return;
            this.loading = true;
            try {
                const res = await send("get", "asset-types", {consumer: 1});
                this.consumer = res?.data?.data ?? [];
                this.loaded = true;
            } catch (e) {
                // Non-fatal: callers fall back to the hardcoded persona list.
            } finally {
                this.loading = false;
            }
        },
    },
});
